import './App.css';
import { Route, Routes } from 'react-router-dom';

import LayoutSimple from './layouts/variations/LayoutSimple';
import { CATALOG_SECTION_KEYS } from './config/catalogSections';

//VISTAS DE LANDING
import HomeView from './views/landing/HomeView';
import CatalogView from './views/landing/CatalogView';
import VisitWorkView from './views/landing/VisitWorkView';

export default function App() {
  return (
    <Routes>  
      {/* RUTAS PARA FRONT CLIENTE */}
      <Route path="/" element={<LayoutSimple />}>
        <Route index element={<HomeView />} />

        {/* Una ruta por sección del catálogo. Todos los segmentos son opcionales:
            /repuestos
            /repuestos/bomag
            /repuestos/bomag/pison-bomag-bt65
            /repuestos/bomag/pison-bomag-bt65/manuales
            /reparacion/bomag/pison-bomag-bt65/equipo/verificar-bujia-28
            /reparacion/bomag/pison-bomag-bt65/equipo/verificar-bujia-28/cambio-de-bujia-540
            El formato viejo (?brand=&product=) redirige desde CatalogView. */}
        {CATALOG_SECTION_KEYS.map(section => (
          <Route
            key={section}
            path={`${section}/:brandSlug?/:productSlug?/:tab?/:solutionParam?/:docParam?`}
            element={<CatalogView section={section} />}
          />
        ))}

        <Route path="garantia" element={<VisitWorkView tipo="garantia" title="Solicitar Garantia de Equipo" img="/assets/img/category/reparar.jpeg" />} />
        <Route path="visitaObra" element={<VisitWorkView />} />
      </Route>
    </Routes>
  );
}
